import styled, { css } from 'styled-components';

const StepIndex = styled.div`
  align-items: center;
  border: 1px solid var(--color-border-default);
  border-radius: 50%;
  display: flex;
  height: 40px;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  width: 40px;

  ${({ isCompleted }) =>
    isCompleted &&
    css`
      background-color: var(--color-success-default);
      border: 1px solid var(--color-success-default);
      color: var(--color-bg-body);
    `}

  ${({ hasWarning }) =>
    hasWarning &&
    css`
      background-color: var(--color-body-default);
      border: 1px solid var(--color-warning-default);
      color: var(--color-bg-body);
    `}
`;

export { StepIndex };
